
import { tryLast, findIndex, indexed, contains, empty as empty_1, singleton as singleton_1, append as append_1, exists, length, sortBy, collect, tryFind, choose, map, isEmpty, filter, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { compareArrays, stringHash, curry3, comparePrimitives, createObj, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { toolStateChangeOptions, elementsRequiringMapping, paletteGroups } from "./Helper.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabeledValue, BlockHeader } from "../../Components/Text.js";
import { NumberInput, Input, IconInput } from "../../Components/Input.js";
import Magnifying_Glass from "../../../public/assets/icons/Magnifying_Glass.svg";
import { SidebarComponentStep, StepElement, DragStepComponent } from "./Components.js";
import { useDrag, useDropGeneric } from "../../Bindings/Fable.ReactDnD.js";
import { EditorTab, DragStepElementOption, DragProcedureStep, Msg } from "./Types.js";
import Hamburger_Menu_1 from "../../../public/assets/icons/Hamburger_Menu_1.svg";
import { Button, TextButton } from "../../Components/Button.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { IconPlay, IconPlus } from "../../Components/Icon.js";
import { WarningAlert } from "../../Components/Alert.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ProcedureTemplateInformationFieldType, ProcedureTemplateHookTriggerType, ProcedureTemplateStepElementType, ProcedureEmail_user, ProcedureEmail_performer, ProcedureEmail_storageManagers, ProcedureEmail_RecipientKind, ProcedureEmail_address, ProcedureEmail_placeholders, ProcedureTemplateState } from "../../Shared/Procedure.js";
import { filter as filter_1, bind, map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { usePermissions, isSystemAccount } from "../../UserPermissions.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { Select, MultiSelect } from "../../Components/Select.js";
import { RoleId__get_unwrap, LabelId__get_unwrap, FormKind, PropertyConfigurationId__get_unwrap, FormState__getValidation } from "../../Shared/Shared.js";
import { PlaceholderTextArea, PlaceholderInput } from "../../Components/PlaceholderInput.js";
import { TextArea } from "../../Components/TextArea.js";
import { name as name_19 } from "../../InventoryStates/Display.js";
import { map as map_2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { filter as filter_2, count, tryFind as tryFind_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FSharpSet__Contains, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { RoleDefinitionModule_isAssignable, Permission, Permissions_has } from "../../Shared/Roles.js";
import Arrow_Left_1 from "../../../public/assets/icons/Arrow_Left_1.svg";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Badge } from "../../Components/Badge.js";
import Download_File from "../../../public/assets/icons/Download_File.svg";
import Multiple_File_1 from "../../../public/assets/icons/Multiple_File_1.svg";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { roleDisplayName } from "../../Common.js";
import { TestProcedureModal } from "../../Widgets/Procedure/Form/View.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initCopy, initEdit, update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

const stickyPanelClasses = ofArray(["sticky", "top-0", "max-h-screen", "overflow-y-auto", "bg-white", "rounded", "p-4"]);

export function Sidebar(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState("");
    const search = patternInput_1[0];
    const groups = filter((group_1) => !isEmpty(group_1.DragSteps), map((group) => ({
        DragSteps: filter((dragStep) => {
            const term = search.trim().toLowerCase();
            if (term === "") {
                return true;
            }
            else {
                return t(dragStep.TranslationKey).toLowerCase().indexOf(term) >= 0;
            }
        }, choose((dragStepType) => tryFind((dragStep_1) => equals(dragStep_1.Type, dragStepType), props.DragSteps), group.Types)),
        TranslationKey: group.TranslationKey,
    }), paletteGroups));
    return reactElement("div", createObj(ofArray([["data-test-id", "procedure-palette"], ["className", join(" ", stickyPanelClasses)], (elems_1 = toList(delay(() => append(singleton(createElement(BlockHeader, {
        Text: t("procedure.step_type.title"),
    })), delay(() => append(singleton(createElement(IconInput, {
        ComponentState: "enabled",
        LeftIcon: Magnifying_Glass(),
        OnChange: patternInput_1[1],
        TestId: "procedure-palette-search",
        Value: search,
    })), delay(() => append(isEmpty(groups) ? singleton(reactElement("div", {
        className: join(" ", ["mt-3", "text-sm", "text-text-muted"]),
        children: t("procedure.palette.no_results"),
    })) : empty(), delay(() => map((group_2) => {
        let elems;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems = toList(delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["text-xs", "font-bold", "text-black", "mb-1"]),
            children: t(group_2.TranslationKey),
        })), delay(() => map((dragStep_2) => createElement(DragStepComponent, {
            ComponentState: props.ComponentState,
            DragStep: dragStep_2,
            OnClick: () => {
                props.OnAdd(dragStep_2.Type);
            },
        }), group_2.DragSteps))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, groups))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Dropzone(props) {
    let elems;
    const patternInput = useTranslation();
    const patternInput_1 = useDropGeneric({
        accept: "STEP_ELEMENT",
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (step) => {
            const matchValue = step.OldPosition;
            if (props.ComponentState === "disabled") {
            }
            else if (matchValue == null) {
                props.Dispatch(new Msg(11, [props.StepPosition, props.StepElementPosition, step.Type]));
            }
            else {
                const oldPosition = matchValue;
                props.Dispatch(new Msg(12, [oldPosition.StepPosition, props.StepPosition, oldPosition.StepElementPosition, props.StepElementPosition]));
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["ref", patternInput_1[1]], ["data-test-id", `procedure-step-dropzone-${props.StepPosition}-${props.StepElementPosition}`], ["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-2"), delay(() => ((dropData.canDrop && dropData.isOver) ? append(singleton("h-8"), delay(() => append(singleton("text-xs"), delay(() => append(singleton("font-bold"), delay(() => singleton("text-primary-link"))))))) : singleton("h-3")))))))))))], (elems = toList(delay(() => ((dropData.canDrop && dropData.isOver) ? append(singleton(reactElement("span", {
        className: join(" ", ["grow", "h-0.5", "bg-primary"]),
    })), delay(() => append(singleton(reactElement("span", {
        children: patternInput[0]("procedure.form.drop_here"),
    })), delay(() => singleton(reactElement("span", {
        className: join(" ", ["grow", "h-0.5", "bg-primary"]),
    })))))) : empty()))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function StepDropzone(props) {
    const patternInput = useDropGeneric({
        accept: "PROCEDURE_STEP",
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedStep) => {
            if ((draggedStep.Position !== props.StepPosition) && (props.ComponentState === "enabled")) {
                props.Dispatch(new Msg(5, [draggedStep.Position, props.StepPosition]));
            }
        },
    });
    const dropData = patternInput[0];
    return reactElement("div", {
        ref: patternInput[1],
        className: join(" ", toList(delay(() => append(singleton("h-2"), delay(() => ((dropData.canDrop && dropData.isOver) ? append(singleton("h-16"), delay(() => append(singleton("rounded"), delay(() => append(singleton("border"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => singleton("bg-primary/10"))))))))))) : empty())))))),
    });
}

export function ProcedureTemplateStep(props) {
    let elems_5, elems_3, elems_4;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => (new DragProcedureStep(props.Step.Position)),
        type: "PROCEDURE_STEP",
    });
    return reactElement("div", createObj(ofArray([["data-test-id", `procedure-step-${props.Step.Position}`], ["className", join(" ", toList(delay(() => append(singleton("bg-white"), delay(() => append(singleton("rounded"), delay(() => append(singleton("border"), delay(() => ((props.IsSelected && (props.SelectedStepElementPosition == null)) ? singleton("border-primary") : singleton("border-white")))))))))))], (elems_5 = [reactElement("div", createObj(ofArray([["data-test-id", `procedure-step-header-${props.Step.Position}`], ["className", join(" ", ["flex", "items-start", "gap-3", "px-6", "pt-5", "pb-3", "cursor-pointer"])], ["onClick", (_arg_1) => {
        props.Dispatch(new Msg(7, [props.Step.Position]));
    }], (elems_3 = toList(delay(() => {
        let elems;
        return append(props.IsEditable ? singleton(reactElement("div", createObj(ofArray([["ref", patternInput_1[1]], ["className", join(" ", ["h-5", "w-5", "mt-1", "shrink-0", "cursor-grab", "text-darkgrey"])], (elems = [Hamburger_Menu_1()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "min-w-0"])], (elems_1 = toList(delay(() => {
                let arg_1;
                return append(singleton(reactElement("div", {
                    className: join(" ", ["text-xs", "text-text-muted"]),
                    children: (arg_1 = {
                        number: props.Step.Position + 1,
                    }, patternInput[1].t("procedure.form.step_number", arg_1)),
                })), delay(() => append(singleton(reactElement("div", {
                    className: join(" ", ["text-xl", "font-bold", "break-words"]),
                    children: props.Step.Name,
                })), delay(() => ((props.Step.Description !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-text-muted", "whitespace-pre-wrap"]),
                    children: props.Step.Description,
                })) : empty())))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2, Label;
                return props.IsEditable ? singleton(reactElement("div", createObj(ofArray([["onClick", (e) => {
                    e.stopPropagation();
                }], (elems_2 = [createElement(TextButton, (Label = t("procedure.form.remove_step"), {
                    ComponentState: props.ComponentState,
                    Icon: Delete_1(),
                    Label: Label,
                    OnClick: () => {
                        props.Dispatch(new Msg(6, [props.Step.Position]));
                    },
                    TestId: `procedure-step-remove-${props.Step.Position}`,
                    Variant: "redButton",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["px-6", "pb-5"])], (elems_4 = toList(delay(() => append(collect((element) => toList(delay(() => append(props.IsEditable ? singleton(createElement(Dropzone, {
        ComponentState: props.ComponentState,
        Dispatch: props.Dispatch,
        StepElementPosition: element.Position,
        StepPosition: props.Step.Position,
    })) : singleton(reactElement("div", {
        className: join(" ", ["h-3"]),
    })), delay(() => singleton(createElement(StepElement, {
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        IsEditable: props.IsEditable,
        IsSelected: props.IsSelected && equals(element.Position, props.SelectedStepElementPosition),
        StepElement: element,
        StepPosition: props.Step.Position,
    })))))), sortBy((_arg_3) => (_arg_3.Position | 0), props.Step.Elements, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })), delay(() => append(isEmpty(props.Step.Elements) ? singleton(reactElement("div", {
        className: join(" ", ["text-sm", "text-text-muted", "py-2"]),
        children: t("procedure.form.empty_step_hint"),
    })) : empty(), delay(() => (props.IsEditable ? singleton(createElement(Dropzone, {
        ComponentState: props.ComponentState,
        Dispatch: props.Dispatch,
        StepElementPosition: length(props.Step.Elements),
        StepPosition: props.Step.Position,
    })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function AddStepButton(props) {
    let elems, Label;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "py-4", "bg-white", "border", "border-dashed", "border-primary", "rounded"])], (elems = [createElement(TextButton, (Label = patternInput[0]("procedure.form.add_step"), {
        ComponentState: props.ComponentState,
        Icon: IconPlus(20),
        Label: Label,
        OnClick: () => {
            props.Dispatch(new Msg(4, []));
        },
        TestId: "procedure-add-step-test-id",
        Variant: "blueButton",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function MappingRequiredAlert(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const matchValue_1 = elementsRequiringMapping(props.ProcedureTemplateForm);
    let matchResult;
    if (props.ProcedureTemplateForm.State.tag === 0) {
        if (!isEmpty(matchValue_1)) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "p-4"])], ["data-test-id", "procedure-template-mapping-required"], (elems_1 = [createElement(WarningAlert, {
                Label: t("procedure_template.mapping_required.title"),
            }), reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "pl-5", "mt-2", "text-sm", "flex", "flex-col", "gap-1"])], (elems = map((element) => {
                let matchValue_3;
                return reactElement("li", {
                    children: concat(element.Label, ": ", ...((matchValue_3 = element.Type, (matchValue_3.tag === 16) ? t("procedure_template.mapping_required.property_configuration") : ((matchValue_3.tag === 20) ? t("procedure_template.mapping_required.email_recipients") : t("procedure_template.mapping_required.inspection_template"))))),
                });
            }, matchValue_1), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return defaultOf();
    }
}

export function MainArea(props) {
    let elems_1;
    const isEditable = equals(props.ProcedureTemplateForm.State, new ProcedureTemplateState(0, []));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "min-w-0"])], (elems_1 = toList(delay(() => append(singleton(createElement(MappingRequiredAlert, {
        ProcedureTemplateForm: props.ProcedureTemplateForm,
    })), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => (isEditable ? append(singleton("gap-1"), delay(() => singleton("-mt-3"))) : singleton("gap-3")))))))))], (elems = toList(delay(() => append(collect((step) => toList(delay(() => append(isEditable ? singleton(createElement(StepDropzone, {
            ComponentState: props.ComponentState,
            Dispatch: props.Dispatch,
            StepPosition: step.Position,
        })) : empty(), delay(() => singleton(createElement(ProcedureTemplateStep, {
            ComponentState: props.ComponentState,
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsEditable: isEditable,
            IsSelected: equals(step.Position, props.SelectedStepPosition),
            SelectedStepElementPosition: unwrap(props.SelectedStepElementPosition),
            Step: step,
        })))))), sortBy((_arg) => (_arg.Position | 0), props.ProcedureTemplateForm.Steps, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })), delay(() => (isEditable ? singleton(createElement(StepDropzone, {
            ComponentState: props.ComponentState,
            Dispatch: props.Dispatch,
            StepPosition: length(props.ProcedureTemplateForm.Steps) - 1,
        })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (isEditable ? singleton(createElement(AddStepButton, {
            ComponentState: props.ComponentState,
            Dispatch: props.Dispatch,
        })) : empty())));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function InspectorStep(props) {
    let elems, arg_1;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["data-test-id", "procedure-step-settings"], ["className", join(" ", stickyPanelClasses)], (elems = [createElement(BlockHeader, {
        Text: patternInput[0]("procedure.form.step_settings"),
    }), reactElement("div", {
        className: join(" ", ["text-xs", "text-text-muted", "-mt-3", "mb-4"]),
        children: (arg_1 = {
            number: props.Position + 1,
        }, patternInput[1].t("procedure.form.step_number", arg_1)),
    }), createElement(SidebarComponentStep, {
        ComponentState: props.ComponentState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        Position: props.Position,
        ProcedureTemplateStep: props.SelectedStep,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function InspectorEmpty() {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", "procedure-properties-empty"], ["className", join(" ", stickyPanelClasses)], (elems = [createElement(BlockHeader, {
        Text: t("procedure.form.properties"),
    }), reactElement("p", {
        className: join(" ", ["text-sm", "text-text-muted"]),
        children: t("procedure.form.no_selection_hint"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function emailPlaceholders(t) {
    return map((key) => ({
        Key: key,
        Label: t(concat("procedure.send_email.placeholder_", ...key)),
    }), ProcedureEmail_placeholders);
}

function SendEmailConfiguration(props) {
    let elems_6;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState("");
    const setNewAddress = patternInput_1[1];
    const newAddress = patternInput_1[0];
    const recipients = props.SelectedStepElement.EmailRecipients;
    const validationKey = (suffix) => (`${props.Position}-${props.SelectedStepElement.Position}-${suffix}`);
    const setRecipients = (updated) => {
        props.Dispatch(new Msg(20, [props.Position, props.SelectedStepElement.Position, updated]));
    };
    const hasKind = (kind) => exists((recipient) => equals(recipient.Kind, kind), recipients);
    const toggleKind = (kind_1, recipient_1, isChecked) => {
        if (isChecked) {
            setRecipients(append_1(recipients, singleton_1(recipient_1)));
        }
        else {
            setRecipients(filter((existing) => !equals(existing.Kind, kind_1), recipients));
        }
    };
    const mailUsers = filter((user) => {
        if (!isSystemAccount(user)) {
            const matchValue = user.LoginInformation;
            if (matchValue.tag === 1) {
                return false;
            }
            else {
                return matchValue.fields[0].trim() !== "";
            }
        }
        else {
            return false;
        }
    }, props.AvailableUsers);
    const selectedUserIds = choose((recipient_2) => {
        const matchValue_2 = recipient_2.UserId;
        let matchResult;
        if (recipient_2.Kind.tag === 1) {
            if (matchValue_2 != null) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return matchValue_2;
            default:
                return undefined;
        }
    }, recipients);
    const userOption = (user_1) => ({
        label: user_1.Name,
        value: user_1.Id,
    });
    const addresses = choose((recipient_3) => {
        const matchValue_5 = recipient_3.Address;
        let matchResult_1;
        if (recipient_3.Kind.tag === 0) {
            if (matchValue_5 != null) {
                matchResult_1 = 0;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0:
                return matchValue_5;
            default:
                return undefined;
        }
    }, recipients);
    const addAddress = () => {
        const address_1 = newAddress.trim();
        if ((address_1 !== "") && !exists((existing_1) => (existing_1.toLowerCase() === address_1.toLowerCase()), addresses)) {
            setRecipients(append_1(recipients, singleton_1(ProcedureEmail_address(address_1))));
        }
        setNewAddress("");
    };
    const isDisabled = props.ComponentState === "disabled";
    return reactElement("div", createObj(ofArray([["data-test-id", "step-element-send-email"], ["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_6 = toList(delay(() => {
        let elems_5;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_5 = toList(delay(() => append(singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: t("procedure.send_email.recipients"),
        })), delay(() => {
            let IsChecked, OnCheck;
            return append(singleton(Checkbox((IsChecked = hasKind(new ProcedureEmail_RecipientKind(2, [])), (OnCheck = curry3(toggleKind)(new ProcedureEmail_RecipientKind(2, []))(ProcedureEmail_storageManagers), {
                ComponentState: props.ComponentState,
                IsChecked: IsChecked,
                Label: t("procedure.send_email.recipient_storage_managers"),
                OnCheck: OnCheck,
                TestId: "step-element-email-storage-managers",
            })))), delay(() => {
                let IsChecked_1, OnCheck_1;
                return append(singleton(Checkbox((IsChecked_1 = hasKind(new ProcedureEmail_RecipientKind(3, [])), (OnCheck_1 = curry3(toggleKind)(new ProcedureEmail_RecipientKind(3, []))(ProcedureEmail_performer), {
                    ComponentState: props.ComponentState,
                    IsChecked: IsChecked_1,
                    Label: t("procedure.send_email.recipient_performer"),
                    OnCheck: OnCheck_1,
                    TestId: "step-element-email-performer",
                })))), delay(() => append(singleton(createElement(MultiSelect, {
                    ComponentState: props.ComponentState,
                    IsClearable: true,
                    Label: t("procedure.send_email.recipient_users"),
                    NoOptionsMessage: "procedure.send_email.no_users",
                    OnChange: (selected) => {
                        const selectedIds = defaultArg(map_1((arg) => map((_arg) => _arg.value, ofArray(arg)), selected), empty_1());
                        setRecipients(append_1(filter((recipient_4) => !equals(recipient_4.Kind, new ProcedureEmail_RecipientKind(1, [])), recipients), map((userId_1) => ProcedureEmail_user(userId_1, map_1((_arg_1) => _arg_1.Name, tryFind((user_3) => (user_3.Id === userId_1), mailUsers))), selectedIds)));
                    },
                    Options: map(userOption, filter((user_2) => !contains(user_2.Id, selectedUserIds, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: (x) => (stringHash(x) | 0),
                    }), mailUsers)),
                    PlaceholderKey: "procedure.send_email.select_users",
                    TestId: "step-element-email-users",
                    Value: map(userOption, filter((user_4) => contains(user_4.Id, selectedUserIds, {
                        Equals: (x_1, y_1) => (x_1 === y_1),
                        GetHashCode: (x_1) => (stringHash(x_1) | 0),
                    }), mailUsers)),
                })), delay(() => {
                    let elems_4;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_4 = toList(delay(() => {
                        let elems_1, elems;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-end", "gap-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], ["onKeyDown", (event) => {
                            if (event.key === "Enter") {
                                event.preventDefault();
                                addAddress();
                            }
                        }], (elems = [createElement(Input, {
                            ComponentState: props.ComponentState,
                            Label: t("procedure.send_email.recipient_addresses"),
                            OnChange: setNewAddress,
                            TestId: "step-element-email-address",
                            Value: newAddress,
                        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextButton, {
                            ComponentState: props.ComponentState,
                            Label: t("procedure.send_email.add_address"),
                            OnClick: addAddress,
                            TestId: "step-element-email-add-address",
                            Variant: "blueButton",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                            let elems_3;
                            return !isEmpty(addresses) ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "step-element-email-addresses"], ["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems_3 = toList(delay(() => map((address_2) => {
                                let elems_2;
                                return reactElement("span", createObj(ofArray([["data-test-id", concat("step-element-email-address-", ...address_2)], ["className", join(" ", ["flex", "items-center", "gap-1", "rounded-xl", "bg-background", "px-2.5", "py-1", "text-sm"])], (elems_2 = [reactElement("span", {
                                    children: address_2,
                                }), reactElement("button", {
                                    type: "button",
                                    disabled: isDisabled,
                                    className: join(" ", ["text-text-muted", "hover:text-black"]),
                                    children: "×",
                                    onClick: (_arg_2) => {
                                        setRecipients(filter((recipient_5) => !(equals(recipient_5.Kind, new ProcedureEmail_RecipientKind(0, [])) && equals(recipient_5.Address, address_2)), recipients));
                                    },
                                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
                            }, addresses))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty();
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                        let matchValue_7, message;
                        return append((matchValue_7 = FormState__getValidation(props.FormState, t, validationKey("email-recipients")), (matchValue_7 == null) ? (empty()) : ((message = matchValue_7, singleton(reactElement("div", {
                            "data-test-id": "step-element-email-recipients-validation",
                            className: join(" ", ["text-red", "text-sm"]),
                            children: message,
                        }))))), delay(() => append(singleton(Checkbox({
                            ComponentState: props.ComponentState,
                            IsChecked: props.SelectedStepElement.AllowRecipientEditing,
                            Label: t("procedure.send_email.allow_recipient_editing"),
                            OnCheck: (isChecked_1) => {
                                props.Dispatch(new Msg(23, [props.Position, props.SelectedStepElement.Position, isChecked_1]));
                            },
                            TestId: "step-element-email-allow-editing",
                        })), delay(() => singleton(reactElement("div", {
                            className: join(" ", ["text-sm", "text-text-muted"]),
                            children: t("procedure.send_email.allow_recipient_editing_info"),
                        }))))));
                    }));
                }))));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => append(singleton(createElement(PlaceholderInput, {
            ComponentState: props.ComponentState,
            Label: t("procedure.send_email.subject"),
            OnChange: (value_44) => {
                props.Dispatch(new Msg(21, [props.Position, props.SelectedStepElement.Position, value_44]));
            },
            Placeholders: emailPlaceholders(t),
            TestId: "step-element-email-subject",
            Value: props.SelectedStepElement.EmailSubject,
        })), delay(() => {
            let matchValue_8, message_1;
            return append((matchValue_8 = FormState__getValidation(props.FormState, t, validationKey("email-subject")), (matchValue_8 == null) ? (empty()) : ((message_1 = matchValue_8, singleton(reactElement("div", {
                "data-test-id": "step-element-email-subject-validation",
                className: join(" ", ["text-red", "text-sm", "-mt-3"]),
                children: message_1,
            }))))), delay(() => append(singleton(createElement(PlaceholderTextArea, {
                ComponentState: props.ComponentState,
                Label: t("procedure.send_email.body"),
                OnChange: (value_50) => {
                    props.Dispatch(new Msg(22, [props.Position, props.SelectedStepElement.Position, value_50]));
                },
                Placeholders: emailPlaceholders(t),
                TestId: "step-element-email-body",
                Value: props.SelectedStepElement.EmailBody,
            })), delay(() => singleton(reactElement("div", {
                className: join(" ", ["text-sm", "text-text-muted"]),
                children: t("procedure.send_email.link_note"),
            }))))));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function OptionRow(props) {
    let elems_3, elems_2;
    const isEnabled = props.ComponentState === "enabled";
    const patternInput = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => (new DragStepElementOption(props.Index)),
        type: "STEP_ELEMENT_OPTION",
    });
    const patternInput_1 = useDropGeneric({
        accept: "STEP_ELEMENT_OPTION",
        collect: (monitor_1) => {
            const isOver = monitor_1.isOver();
            return {
                canDrop: monitor_1.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedOption) => {
            if (draggedOption.Index !== props.Index) {
                props.Dispatch(new Msg(27, [props.StepPosition, props.StepElementPosition, draggedOption.Index, props.Index]));
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["ref", patternInput_1[1]], ["data-test-id", `procedure-template-element-option-${props.Index}`], ["className", join(" ", toList(delay(() => append(singleton("rounded"), delay(() => ((dropData.canDrop && dropData.isOver) ? append(singleton("outline"), delay(() => append(singleton("outline-2"), delay(() => singleton("outline-primary"))))) : empty()))))))], (elems_3 = [reactElement("div", createObj(ofArray([["ref", patternInput[2]], ["className", join(" ", ["flex", "flex-row", "gap-2", "items-center", "bg-white"])], (elems_2 = toList(delay(() => {
        let elems;
        return append(isEnabled ? singleton(reactElement("div", createObj(ofArray([["ref", patternInput[1]], ["data-test-id", `procedure-template-element-option-handle-${props.Index}`], ["className", join(" ", ["h-4", "w-4", "shrink-0", "cursor-grab", "text-darkgrey"])], (elems = [Hamburger_Menu_1()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], (elems_1 = [createElement(Input, {
                ComponentState: props.ComponentState,
                OnChange: (value_12) => {
                    props.Dispatch(new Msg(26, [props.StepPosition, props.StepElementPosition, props.Index, value_12]));
                },
                TestId: "procedure-template-element-option-input",
                Value: props.Value,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (isEnabled ? singleton(reactElement("button", {
                className: join(" ", ["text-red", "hover:text-red", "p-1", "text-sm"]),
                onClick: (_arg_1) => {
                    props.Dispatch(new Msg(25, [props.StepPosition, props.StepElementPosition, props.Index]));
                },
                children: "✕",
            })) : empty())));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function InspectorStepElement(props) {
    let elems_12, elems_11;
    const patternInput = useTranslation();
    const t = patternInput[0];
    let hasOptions;
    const matchValue = props.SelectedStepElement.Type;
    switch (matchValue.tag) {
        case 9:
        case 10:
        case 11: {
            hasOptions = true;
            break;
        }
        default:
            hasOptions = false;
    }
    const isImageType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(12, []));
    const isInspectionResultType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(14, []));
    const isDocumentType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(15, []));
    const isToolStateChangeType = equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(17, []));
    const fileUploadId = `image-upload-${props.Position}-${props.SelectedStepElement.Position}`;
    let stepNumberLabel;
    const arg_1 = {
        number: props.Position + 1,
    };
    stepNumberLabel = (patternInput[1].t("procedure.form.step_number", arg_1));
    let stepElementTypeTitle;
    const matchValue_1 = props.SelectedStepElement.Type;
    switch (matchValue_1.tag) {
        case 1: {
            stepElementTypeTitle = t("procedure.step_type.text_area");
            break;
        }
        case 3:
        case 4: {
            stepElementTypeTitle = t("procedure.step_type.number_input");
            break;
        }
        case 5: {
            stepElementTypeTitle = t("procedure.step_type.yes_no");
            break;
        }
        case 9: {
            stepElementTypeTitle = t("procedure.step_type.single_select");
            break;
        }
        case 10: {
            stepElementTypeTitle = t("procedure.step_type.multi_select");
            break;
        }
        case 11: {
            stepElementTypeTitle = t("procedure.step_type.radio_select");
            break;
        }
        case 6: {
            stepElementTypeTitle = t("procedure.step_type.date_time");
            break;
        }
        case 7: {
            stepElementTypeTitle = t("procedure.step_type.location");
            break;
        }
        case 8: {
            stepElementTypeTitle = t("procedure.step_type.signature");
            break;
        }
        case 2: {
            stepElementTypeTitle = t("procedure.step_type.text_block");
            break;
        }
        case 12: {
            stepElementTypeTitle = t("procedure.step_type.image");
            break;
        }
        case 13: {
            stepElementTypeTitle = t("procedure.step_type.photo_capture");
            break;
        }
        case 14: {
            stepElementTypeTitle = t("procedure.step_type.inspection_result");
            break;
        }
        case 15: {
            stepElementTypeTitle = t("procedure.step_type.document_upload");
            break;
        }
        case 16: {
            stepElementTypeTitle = t("procedure.step_type.custom_field");
            break;
        }
        case 17: {
            stepElementTypeTitle = t("procedure.step_type.tool_state_change");
            break;
        }
        case 18: {
            stepElementTypeTitle = t("procedure.step_type.storage_transfer");
            break;
        }
        case 19: {
            stepElementTypeTitle = t("procedure.step_type.reminder_completion");
            break;
        }
        case 20: {
            stepElementTypeTitle = t("procedure.step_type.send_email");
            break;
        }
        default:
            stepElementTypeTitle = t("procedure.step_type.text_input");
    }
    return reactElement("div", createObj(ofArray([["data-test-id", "procedure-element-properties"], ["className", join(" ", stickyPanelClasses)], (elems_12 = [createElement(BlockHeader, {
        Text: t("procedure.form.properties"),
    }), reactElement("div", {
        className: join(" ", ["text-xs", "text-text-muted", "-mt-3", "mb-4"]),
        children: concat(stepNumberLabel, " · ", ...stepElementTypeTitle),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_11 = toList(delay(() => {
        let matchValue_2;
        return append((matchValue_2 = props.SelectedStepElement.Type, (matchValue_2.tag === 2) ? singleton(createElement(TextArea, {
            ComponentState: props.ComponentState,
            Label: t("general.description"),
            OnChange: (value_7) => {
                props.Dispatch(new Msg(15, [props.Position, props.SelectedStepElement.Position, value_7]));
            },
            TestId: "procedure-template-element-description-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
            Value: props.SelectedStepElement.Label,
        })) : ((matchValue_2.tag === 12) ? singleton(createElement(Input, {
            ComponentState: props.ComponentState,
            Label: t("general.description"),
            OnChange: (value_8) => {
                props.Dispatch(new Msg(15, [props.Position, props.SelectedStepElement.Position, value_8]));
            },
            TestId: "procedure-template-element-description-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
            Value: props.SelectedStepElement.Label,
        })) : singleton(createElement(Input, {
            ComponentState: props.ComponentState,
            Label: t("general.name"),
            OnChange: (value_9) => {
                props.Dispatch(new Msg(15, [props.Position, props.SelectedStepElement.Position, value_9]));
            },
            TestId: "procedure-template-element-name-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
            Value: props.SelectedStepElement.Label,
        })))), delay(() => {
            let matchValue_3;
            return append((matchValue_3 = props.SelectedStepElement.Type, (matchValue_3.tag === 2) ? (empty()) : ((matchValue_3.tag === 12) ? (empty()) : ((matchValue_3.tag === 17) ? (empty()) : ((matchValue_3.tag === 18) ? (empty()) : ((matchValue_3.tag === 19) ? (empty()) : ((matchValue_3.tag === 20) ? (empty()) : singleton(Checkbox({
                ComponentState: props.ComponentState,
                IsChecked: props.SelectedStepElement.Required,
                Label: t("general.required"),
                OnCheck: (value_10) => {
                    props.Dispatch(new Msg(16, [props.Position, props.SelectedStepElement.Position, value_10]));
                },
                TestId: "step-element-required-checkbox",
            })))))))), delay(() => {
                let matchValue_4, elems, Label_4, Value_3, Label_5, Value_4;
                return append((matchValue_4 = props.SelectedStepElement.Type, (matchValue_4.tag === 13) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems = [createElement(NumberInput, (Label_4 = t("procedure.photo_capture.min_count"), (Value_3 = map_1((value_12) => value_12, props.SelectedStepElement.MinCount), {
                    ComponentState: props.ComponentState,
                    Label: unwrap(Label_4),
                    OnChange: (value_13) => {
                        props.Dispatch(new Msg(17, [props.Position, props.SelectedStepElement.Position, map_1((value_14) => (~~value_14 | 0), value_13)]));
                    },
                    TestId: "step-element-photo-min-count",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-${props.SelectedStepElement.Position}-photo-count`)),
                    Value: unwrap(Value_3),
                }))), createElement(NumberInput, (Label_5 = t("procedure.photo_capture.max_count"), (Value_4 = map_1((value_15) => value_15, props.SelectedStepElement.MaxCount), {
                    ComponentState: props.ComponentState,
                    Label: unwrap(Label_5),
                    OnChange: (value_16) => {
                        props.Dispatch(new Msg(18, [props.Position, props.SelectedStepElement.Position, map_1((value_17) => (~~value_17 | 0), value_16)]));
                    },
                    TestId: "step-element-photo-max-count",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-${props.SelectedStepElement.Position}-photo-count`)),
                    Value: unwrap(Value_4),
                })))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : ((matchValue_4.tag === 20) ? singleton(createElement(SendEmailConfiguration, {
                    AvailableUsers: props.AvailableUsers,
                    ComponentState: props.ComponentState,
                    Dispatch: props.Dispatch,
                    FormState: props.FormState,
                    Position: props.Position,
                    SelectedStepElement: props.SelectedStepElement,
                })) : (empty()))), delay(() => {
                    let elems_1;
                    return append(hasOptions ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = toList(delay(() => append(singleton(reactElement("label", {
                        className: join(" ", ["text-sm", "font-bold"]),
                        children: t("procedure.step_type.options"),
                    })), delay(() => append(map((tupledArg) => createElement(OptionRow, {
                        ComponentState: props.ComponentState,
                        Dispatch: props.Dispatch,
                        Index: tupledArg[0],
                        StepElementPosition: props.SelectedStepElement.Position,
                        StepPosition: props.Position,
                        Value: tupledArg[1],
                    }), indexed(props.SelectedStepElement.Options)), delay(() => singleton(createElement(TextButton, {
                        ComponentState: props.ComponentState,
                        Label: t("procedure.step_type.add_option"),
                        OnClick: () => {
                            props.Dispatch(new Msg(24, [props.Position, props.SelectedStepElement.Position, ""]));
                        },
                        TestId: "add-option-button",
                        Variant: "blueButton",
                    })))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty(), delay(() => {
                        let elems_6, elems_4, elems_5;
                        return append(isImageType ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_6 = [reactElement("label", {
                            className: join(" ", ["text-sm", "font-bold"]),
                            children: t("procedure.step_type.images"),
                        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems_4 = toList(delay(() => map((tupledArg_1) => {
                            let elems_3;
                            return reactElement("div", createObj(ofArray([["className", join(" ", ["relative"])], (elems_3 = toList(delay(() => {
                                let elems_2;
                                return append((props.ComponentState === "enabled") ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "top-1", "right-1", "h-5", "w-5", "p-1", "rounded-full", "text-red", "bg-white", "cursor-pointer", "shadow"])], ["onClick", (e) => {
                                    e.preventDefault();
                                    props.Dispatch(new Msg(30, [props.Position, props.SelectedStepElement.Position, tupledArg_1[0]]));
                                }], (elems_2 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty(), delay(() => singleton(reactElement("img", {
                                    className: join(" ", ["shadow", "rounded", "border", "w-24", "h-20", "object-cover"]),
                                    src: tupledArg_1[1],
                                }))));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                        }, indexed(props.SelectedStepElement.Options)))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(singleton_1((elems_5 = [createElement(TextButton, {
                            ComponentState: props.ComponentState,
                            Label: t("procedure.step_type.upload_image"),
                            OnClick: () => {
                                const element = document.getElementById(fileUploadId);
                                element.click();
                            },
                            TestId: "upload-image-button",
                            Variant: "blueButton",
                        }), reactElement("input", {
                            id: fileUploadId,
                            className: join(" ", ["hidden"]),
                            type: "file",
                            accept: ".jpg, .jpeg, .png",
                            onChange: (ev) => {
                                const files = ev.target.files;
                                if (!(files == null) && (files.length > 0)) {
                                    props.Dispatch(new Msg(28, [props.Position, props.SelectedStepElement.Position, files.item(0)]));
                                }
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_5))]))))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty(), delay(() => {
                            let elems_7, Label_8, Options;
                            return append(isInspectionResultType ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_7 = [createElement(Select, (Label_8 = t("procedure.step_type.inspection_template"), (Options = map((template) => ({
                                label: template.Name,
                                value: template.Id,
                            }), props.AvailableInspectionTemplates), {
                                ComponentState: props.ComponentState,
                                IsClearable: true,
                                Label: unwrap(Label_8),
                                NoOptionsMessage: t("procedure.step_type.no_inspection_templates"),
                                OnChange: (selected) => {
                                    props.Dispatch(new Msg(31, [props.Position, props.SelectedStepElement.Position, map_1((s) => s.value, selected)]));
                                },
                                Options: Options,
                                PlaceholderKey: "general.select",
                                TestId: "inspection-template-select",
                                Value: unwrap(bind((id) => map_1((t_2) => ({
                                    label: t_2.Name,
                                    value: t_2.Id,
                                }), tryFind((t_1) => (t_1.Id === id), props.AvailableInspectionTemplates)), props.SelectedStepElement.InspectionTemplateId)),
                            }))), Checkbox({
                                ComponentState: props.ComponentState,
                                IsChecked: props.SelectedStepElement.AttachProtocolPdf,
                                Label: t("procedure.inspection_result.attach_protocol_pdf"),
                                OnCheck: (value_49) => {
                                    props.Dispatch(new Msg(19, [props.Position, props.SelectedStepElement.Position, value_49]));
                                },
                                TestId: "step-element-attach-protocol-pdf-checkbox",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty(), delay(() => {
                                let elems_8;
                                return append(isToolStateChangeType ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_8 = toList(delay(() => append(singleton(reactElement("label", {
                                    className: join(" ", ["text-sm", "font-bold"]),
                                    children: t("procedure.tool_state_change.allowed_states"),
                                })), delay(() => map((definition) => {
                                    const stateString = definition.Key;
                                    const isChecked = contains(stateString, props.SelectedStepElement.Options, {
                                        Equals: (x, y) => (x === y),
                                        GetHashCode: (x) => (stringHash(x) | 0),
                                    });
                                    return Checkbox({
                                        ComponentState: props.ComponentState,
                                        IsChecked: isChecked,
                                        Label: name_19(t, definition),
                                        OnCheck: (newChecked) => {
                                            if (newChecked && !isChecked) {
                                                props.Dispatch(new Msg(24, [props.Position, props.SelectedStepElement.Position, stateString]));
                                            }
                                            else if (!newChecked && isChecked) {
                                                props.Dispatch(new Msg(25, [props.Position, props.SelectedStepElement.Position, findIndex((o) => (o === stateString), props.SelectedStepElement.Options)]));
                                            }
                                        },
                                        TestId: concat("tool-state-change-allowed-", ...stateString),
                                    });
                                }, props.ToolStates))))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty(), delay(() => {
                                    let elems_9, Label_11, Options_1;
                                    return append(equals(props.SelectedStepElement.Type, new ProcedureTemplateStepElementType(16, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_9 = [createElement(Select, (Label_11 = t("procedure.step_type.property_configuration"), (Options_1 = map((pc) => ({
                                        label: pc.Name,
                                        value: PropertyConfigurationId__get_unwrap(pc.Id),
                                    }), props.PropertyConfigurations), {
                                        ComponentState: props.ComponentState,
                                        IsClearable: true,
                                        Label: unwrap(Label_11),
                                        NoOptionsMessage: t("procedure.step_type.no_property_configurations"),
                                        OnChange: (selected_1) => {
                                            props.Dispatch(new Msg(32, [props.Position, props.SelectedStepElement.Position, map_1((s_1) => s_1.value, selected_1)]));
                                        },
                                        Options: Options_1,
                                        PlaceholderKey: "general.select",
                                        TestId: "property-configuration-select",
                                        Value: unwrap(bind((id_1) => map_1((pc_2) => ({
                                            label: pc_2.Name,
                                            value: PropertyConfigurationId__get_unwrap(pc_2.Id),
                                        }), tryFind((pc_1) => (PropertyConfigurationId__get_unwrap(pc_1.Id) === id_1), props.PropertyConfigurations)), props.SelectedStepElement.PropertyConfigurationId)),
                                    })))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty(), delay(() => {
                                        let elems_10;
                                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2", "pt-4", "border-t", "border-divider"])], (elems_10 = [createElement(Button, {
                                            ComponentState: props.ComponentState,
                                            Label: t("general.duplicate"),
                                            OnClick: () => {
                                                props.Dispatch(new Msg(14, [props.Position, props.SelectedStepElement.Position]));
                                            },
                                            TestId: "duplicate-step-element-button",
                                            Variant: "secondary",
                                        }), createElement(Button, {
                                            ComponentState: props.ComponentState,
                                            Label: t("general.remove"),
                                            OnClick: () => {
                                                props.Dispatch(new Msg(13, [props.Position, props.SelectedStepElement.Position]));
                                            },
                                            TestId: "remove-step-button-test-id",
                                            Variant: "redButton",
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

export function getTriggerTypeLabel(t, triggerType) {
    switch (triggerType.tag) {
        case 1:
            return t("procedure.hooks.trigger_type.assignment_sender");
        case 2:
            return t("procedure.hooks.trigger_type.return_receiver");
        case 3:
            return t("procedure.hooks.trigger_type.return_sender");
        case 4:
            return t("procedure.hooks.trigger_type.handover");
        case 5:
            return t("procedure.hooks.trigger_type.reservation");
        case 6:
            return t("procedure.hooks.trigger_type.status_change");
        case 7:
        case 8:
            return t("procedure.hooks.trigger_type.manual");
        default:
            return t("procedure.hooks.trigger_type.assignment_receiver");
    }
}

export function HookConfiguration(props) {
    let elems_3;
    const t = useTranslation()[0];
    const isManualHook = equals(props.TriggerType, new ProcedureTemplateHookTriggerType(7, [])) ? true : equals(props.TriggerType, new ProcedureTemplateHookTriggerType(8, []));
    const targetStateOptions = map((definition) => ({
        label: name_19(t, definition),
        value: definition.Key,
    }), props.TargetStates);
    return reactElement("div", createObj(ofArray([["data-test-id", `hook-configuration-${props.TriggerType}`], ["className", join(" ", ["flex", "flex-col", "gap-3", "mt-3", "ml-6", "max-w-[30rem]"])], (elems_3 = toList(delay(() => append(!isManualHook ? singleton(Checkbox({
        ComponentState: props.ComponentState,
        IsChecked: props.HookState.IsMandatory,
        Label: t("procedure.hooks.is_mandatory"),
        OnCheck: (checked$0027) => {
            props.Dispatch(new Msg(37, [props.TriggerType, checked$0027]));
        },
        TestId: `hook-mandatory-${props.TriggerType}`,
    })) : empty(), delay(() => {
        let elems;
        return append(equals(props.TriggerType, new ProcedureTemplateHookTriggerType(6, [])) ? singleton(reactElement("div", createObj(singleton_1((elems = [createElement(Select, {
            ComponentState: props.ComponentState,
            IsClearable: false,
            Label: t("procedure.hooks.target_state"),
            NoOptionsMessage: t("procedure.hooks.no_labels"),
            OnChange: (selected) => {
                props.Dispatch(new Msg(41, [props.TriggerType, map_1((option) => option.value, selected)]));
            },
            Options: targetStateOptions,
            PlaceholderKey: "general.select",
            TestId: `hook-target-state-${props.TriggerType}`,
            Value: unwrap(bind((key_3) => tryFind((option_2) => (option_2.value === key_3), targetStateOptions), props.HookState.TargetStateKey)),
        }), reactElement("p", {
            className: join(" ", ["text-xs", "text-text-muted", "mt-1"]),
            children: t("procedure.hooks.target_state_info"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))]))))) : empty(), delay(() => {
            let elems_1;
            return append(isManualHook ? singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(MultiSelect, {
                ComponentState: props.ComponentState,
                IsClearable: true,
                Label: t("procedure.hooks.roles"),
                NoOptionsMessage: "procedure.hooks.no_roles",
                OnChange: (selectedOptions) => {
                    props.Dispatch(new Msg(42, [props.TriggerType, defaultArg(map_1((arg) => ofArray(map_2((opt) => parse(opt.value), arg)), selectedOptions), empty_1())]));
                },
                Options: props.AvailableRoles,
                PlaceholderKey: "procedure.hooks.all_roles",
                TestId: `hook-roles-${props.TriggerType}`,
                Value: choose((roleId) => tryFind((opt_1) => (opt_1.value === roleId), props.AvailableRoles), props.HookState.RoleIds),
            }), reactElement("p", {
                className: join(" ", ["text-xs", "text-text-muted", "mt-1"]),
                children: t("procedure.hooks.manual_roles_info"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))) : empty(), delay(() => {
                let elems_2;
                return singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(MultiSelect, {
                    ComponentState: props.ComponentState,
                    IsClearable: true,
                    Label: t("procedure.hooks.labels"),
                    NoOptionsMessage: "procedure.hooks.no_labels",
                    OnChange: (selectedOptions_1) => {
                        props.Dispatch(new Msg(40, [props.TriggerType, defaultArg(map_1((arg_1) => ofArray(map_2((opt_2) => parse(opt_2.value), arg_1)), selectedOptions_1), empty_1())]));
                    },
                    Options: props.AvailableLabels,
                    PlaceholderKey: "general.select",
                    TestId: `hook-labels-${props.TriggerType}`,
                    Value: choose((labelId) => tryFind((opt_3) => (opt_3.value === labelId), props.AvailableLabels), props.HookState.LabelIds),
                }), reactElement("p", {
                    className: join(" ", ["text-xs", "text-text-muted", "mt-1"]),
                    children: t("procedure.hooks.labels_info"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

const hookGroups = ofArray([{
    TranslationKey: "procedure.hooks.group_assignment",
    TriggerTypes: ofArray([new ProcedureTemplateHookTriggerType(1, []), new ProcedureTemplateHookTriggerType(0, []), new ProcedureTemplateHookTriggerType(3, []), new ProcedureTemplateHookTriggerType(2, [])]),
}, {
    TranslationKey: "procedure.hooks.group_status",
    TriggerTypes: singleton_1(new ProcedureTemplateHookTriggerType(6, [])),
}, {
    TranslationKey: "procedure.hooks.group_manual",
    TriggerTypes: singleton_1(new ProcedureTemplateHookTriggerType(8, [])),
}]);

export function HooksTab(props) {
    let elems_3;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", "procedure-template-hooks-tab"], ["className", join(" ", ["flex", "flex-col", "max-w-[55rem]"])], (elems_3 = toList(delay(() => append(singleton(reactElement("p", {
        className: join(" ", ["text-sm", "text-text-muted"]),
        children: t("procedure.hooks.description"),
    })), delay(() => append(map((group) => {
        let Title, elems_1;
        return createElement(SectionContainer, (Title = t(group.TranslationKey), {
            Content: reactElement("div", createObj(singleton_1((elems_1 = map((triggerType) => {
                let elems;
                const hookState = filter_1((_arg) => _arg.IsEnabled, tryFind_1(triggerType, props.Hooks));
                return reactElement("div", createObj(ofArray([["data-test-id", `hook-row-${triggerType}`], ["className", join(" ", ["py-3", "border-b", "border-divider", "last:border-b-0"])], (elems = toList(delay(() => append(singleton(Checkbox({
                    ComponentState: props.ComponentState,
                    IsChecked: hookState != null,
                    Label: getTriggerTypeLabel(t, triggerType),
                    OnCheck: (_arg_1) => {
                        props.Dispatch(new Msg(36, [triggerType]));
                    },
                    TestId: `hook-toggle-${triggerType}`,
                })), delay(() => {
                    const matchValue = hookState;
                    if (matchValue == null) {
                        return empty();
                    }
                    else {
                        const hookState_1 = matchValue;
                        return singleton(createElement(HookConfiguration, {
                            AvailableLabels: props.AvailableLabels,
                            AvailableRoles: props.AvailableRoles,
                            ComponentState: props.ComponentState,
                            Dispatch: props.Dispatch,
                            HookState: hookState_1,
                            TargetStates: filter((definition) => {
                                if (!definition.IsArchived) {
                                    return true;
                                }
                                else {
                                    return equals(hookState_1.TargetStateKey, definition.Key);
                                }
                            }, props.TargetStates),
                            TriggerType: triggerType,
                        }));
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
            }, group.TriggerTypes), ["children", reactApi.Children.toArray(Array.from(elems_1))])))),
            Title: unwrap(Title),
        }));
    }, hookGroups), delay(() => {
        let elems_2;
        if (props.ProcedureTemplateForm.State.tag === 2) {
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mt-6"])], (elems_2 = [createElement(Button, {
                ComponentState: props.ComponentState,
                Label: t("procedure.hooks.save_hooks"),
                OnClick: () => {
                    props.Dispatch(new Msg(55, []));
                },
                TestId: "save-hooks-button",
                Variant: "primary",
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }
        else {
            return empty();
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function GeneralTab(props) {
    let elems_3, Title, elems, Title_1, elems_2;
    const t = useTranslation()[0];
    const isDraft = equals(props.ProcedureTemplateForm.State, new ProcedureTemplateState(0, []));
    const getInformationFieldLabel = (fieldType) => {
        switch (fieldType.tag) {
            case 1:
                return t("procedure.information_fields.manufacturer");
            case 2:
                return t("procedure.information_fields.model");
            case 3:
                return t("procedure.information_fields.serial_number");
            case 4:
                return t("procedure.information_fields.inventory_number");
            case 5:
                return t("procedure.information_fields.comment");
            case 6:
                return t("procedure.information_fields.storage_name");
            case 7:
                return t("procedure.information_fields.storage_space");
            case 8:
                return defaultArg(map_1((_arg) => _arg.Name, tryFind((pc) => (PropertyConfigurationId__get_unwrap(pc.Id) === fieldType.fields[0]), props.PropertyConfigurations)), t("procedure.information_fields.custom_field"));
            default:
                return t("procedure.information_fields.display_name");
        }
    };
    const fieldTypeKey = (fieldType_1) => {
        if (fieldType_1.tag === 8) {
            return concat("custom_", ...fieldType_1.fields[0]);
        }
        else {
            return toString(fieldType_1);
        }
    };
    let availableFieldTypes;
    const customFieldTypes = map((pc_1) => (new ProcedureTemplateInformationFieldType(8, [PropertyConfigurationId__get_unwrap(pc_1.Id)])), props.PropertyConfigurations);
    const usedFieldTypeKeys = ofList(map((field) => fieldTypeKey(field.FieldType), props.ProcedureTemplateForm.InformationFields), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    availableFieldTypes = filter((fieldType_2) => !FSharpSet__Contains(usedFieldTypeKeys, fieldTypeKey(fieldType_2)), append_1(ofArray([new ProcedureTemplateInformationFieldType(0, []), new ProcedureTemplateInformationFieldType(1, []), new ProcedureTemplateInformationFieldType(2, []), new ProcedureTemplateInformationFieldType(3, []), new ProcedureTemplateInformationFieldType(4, []), new ProcedureTemplateInformationFieldType(5, []), new ProcedureTemplateInformationFieldType(6, []), new ProcedureTemplateInformationFieldType(7, [])]), customFieldTypes));
    return reactElement("div", createObj(ofArray([["data-test-id", "procedure-template-general-tab"], ["className", join(" ", ["flex", "flex-col", "max-w-[45rem]"])], (elems_3 = [createElement(MappingRequiredAlert, {
        ProcedureTemplateForm: props.ProcedureTemplateForm,
    }), createElement(SectionContainer, (Title = t("procedure.form.basic_settings"), {
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = toList(delay(() => (isDraft ? append(singleton(createElement(Input, {
            ComponentState: props.ComponentState,
            Label: t("procedure.form.procedure_template_name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(1, [arg]));
            },
            TestId: "procedure-template-name-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "procedure_template_name")),
            Value: props.ProcedureTemplateForm.Name,
        })), delay(() => singleton(createElement(TextArea, {
            ComponentState: props.ComponentState,
            Label: t("procedure.form.procedure_template_description"),
            OnChange: (arg_1) => {
                props.Dispatch(new Msg(2, [arg_1]));
            },
            TestId: "procedure-template-description-input",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "procedure_template_description")),
            Value: props.ProcedureTemplateForm.Description,
        })))) : append(singleton(LabeledValue({
            Label: t("procedure.form.procedure_template_name"),
            Value: props.ProcedureTemplateForm.Name,
        })), delay(() => singleton(LabeledValue({
            Label: t("procedure.form.procedure_template_description"),
            Value: props.ProcedureTemplateForm.Description,
        }))))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))),
        Title: unwrap(Title),
    })), createElement(SectionContainer, (Title_1 = t("procedure.information_fields.title"), {
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_2 = toList(delay(() => append(singleton(reactElement("p", {
            className: join(" ", ["text-sm", "text-text-muted"]),
            children: t("procedure.information_fields.description"),
        })), delay(() => append(map((field_1) => {
            let elems_1;
            const key_8 = fieldTypeKey(field_1.FieldType);
            return reactElement("div", createObj(ofArray([["data-test-id", concat("procedure-template-information-field-", ...key_8)], ["className", join(" ", ["flex", "items-center", "justify-between", "h-12", "px-3", "border", "border-border", "rounded"])], (elems_1 = toList(delay(() => append(singleton(reactElement("span", {
                className: join(" ", ["text-sm"]),
                children: getInformationFieldLabel(field_1.FieldType),
            })), delay(() => {
                let Label_2;
                return isDraft ? singleton(createElement(TextButton, (Label_2 = t("general.remove"), {
                    ComponentState: props.ComponentState,
                    Icon: Delete_1(),
                    Label: Label_2,
                    OnClick: () => {
                        props.Dispatch(new Msg(34, [field_1.Position]));
                    },
                    TestId: concat("procedure-template-information-field-remove-", ...key_8),
                    Variant: "redButton",
                }))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        }, sortBy((_arg_1) => (_arg_1.Position | 0), props.ProcedureTemplateForm.InformationFields, {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        })), delay(() => ((isDraft && !isEmpty(availableFieldTypes)) ? singleton(createElement(Select, {
            ComponentState: props.ComponentState,
            IsClearable: false,
            NoOptionsMessage: "procedure.information_fields.no_more_fields",
            OnChange: (selected) => {
                if (selected == null) {
                }
                else {
                    props.Dispatch(new Msg(33, [selected.value]));
                }
            },
            Options: map((fieldType_3) => ({
                label: getInformationFieldLabel(fieldType_3),
                value: fieldType_3,
            }), availableFieldTypes),
            PlaceholderKey: "procedure.information_fields.add_field",
            TestId: "add-information-field-select",
        })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
        Title: unwrap(Title_1),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function EditorHeader(props) {
    let elems_4, elems_3, Label_3, elems, elems_2;
    const t = useTranslation()[0];
    const canExport = Permissions_has(usePermissions(), new Permission(95, []));
    const isExisting = equals(props.State.FormKind, new FormKind(1, [])) && (props.State.ProcedureTemplateId != null);
    const hooksTabLabel = t("procedure.hooks.title");
    const enabledHookCount = count(filter_2((_arg, hook) => hook.IsEnabled, props.State.Hooks)) | 0;
    let stateBadge;
    const matchValue = props.ProcedureTemplateForm.State;
    stateBadge = ((matchValue.tag === 2) ? {
        Color: "#14BC9C",
        Label: t("procedure.state.released"),
    } : ((matchValue.tag === 1) ? {
        Color: "#E1E7F0",
        Label: t("procedure.state.archived"),
    } : {
        Color: "#F0C416",
        Label: t("procedure.state.draft"),
    }));
    const tab = (editorTab, label, testId) => ({
        IsSelected: equals(props.State.ActiveTab, editorTab),
        Label: label,
        OnClick: (_arg_1) => {
            props.Dispatch(new Msg(0, [editorTab]));
        },
        TestId: testId,
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "mb-6"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-x-6", "gap-y-3"])], (elems_3 = [createElement(TextButton, (Label_3 = t("general.overview"), {
        ComponentState: "enabled",
        Icon: Arrow_Left_1(),
        Label: Label_3,
        OnClick: () => {
            RouterModule_nav(ofArray(["procedure-templates"]), 1, 1);
        },
        TestId: "back-to-overview-button",
        Variant: "default",
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3", "grow", "min-w-0"])], (elems = [reactElement("h1", {
        "data-test-id": "procedure-template-title",
        className: join(" ", ["text-xl", "font-bold", "truncate"]),
        children: props.ProcedureTemplateForm.Name,
    }), createElement(Badge, {
        Color: stateBadge.Color,
        Label: stateBadge.Label,
        TestId: "procedure-template-state",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-5"])], (elems_2 = toList(delay(() => {
        let Label_4;
        return append(singleton(createElement(TextButton, (Label_4 = t("procedure_template.test.button"), {
            ComponentState: props.ComponentState,
            Icon: IconPlay(20),
            Label: Label_4,
            OnClick: () => {
                props.Dispatch(new Msg(67, []));
            },
            TestId: "test-procedure-template-button",
            Variant: "default",
        }))), delay(() => {
            let Label_5;
            return append(isExisting ? append(canExport ? singleton(createElement(TextButton, (Label_5 = t("procedure_template.export.button"), {
                ComponentState: props.ComponentState,
                Icon: Download_File(),
                Label: Label_5,
                OnClick: () => {
                    props.Dispatch(new Msg(65, []));
                },
                TestId: "export-procedure-template-button",
                Variant: "default",
            }))) : empty(), delay(() => {
                let Label_6;
                return singleton(createElement(TextButton, (Label_6 = t("general.duplicate"), {
                    ComponentState: props.ComponentState,
                    Icon: Multiple_File_1(),
                    Label: Label_6,
                    OnClick: () => {
                        props.Dispatch(new Msg(69, []));
                    },
                    TestId: "duplicate-procedure-template-button",
                    Variant: "default",
                })));
            })) : empty(), delay(() => {
                let matchValue_2, Label_7, Label_8;
                return append((matchValue_2 = props.ProcedureTemplateForm.State, (props.State.ProcedureTemplateId != null) ? ((matchValue_2.tag === 0) ? singleton(createElement(TextButton, (Label_7 = t("procedure.action.delete"), {
                    ComponentState: props.ComponentState,
                    Icon: Delete_1(),
                    Label: Label_7,
                    OnClick: () => {
                        props.Dispatch(new Msg(61, []));
                    },
                    TestId: "delete-procedure-template",
                    Variant: "redButton",
                }))) : ((matchValue_2.tag === 2) ? singleton(createElement(TextButton, (Label_8 = t("procedure.action.archive"), {
                    ComponentState: props.ComponentState,
                    Icon: Delete_1(),
                    Label: Label_8,
                    OnClick: () => {
                        props.Dispatch(new Msg(57, []));
                    },
                    TestId: "archive-procedure-template",
                    Variant: "redButton",
                }))) : (empty()))) : (empty())), delay(() => {
                    let elems_1;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2"])], (elems_1 = toList(delay(() => append((props.State.ProcedureTemplateId != null) ? ((props.ProcedureTemplateForm.State.tag === 0) ? singleton(createElement(Button, {
                        ComponentState: props.ComponentState,
                        Label: t("procedure.action.release"),
                        OnClick: () => {
                            props.Dispatch(new Msg(51, []));
                        },
                        TestId: "release-procedure-template",
                        Variant: "blueButton",
                    })) : (empty())) : (empty()), delay(() => {
                        if (props.ProcedureTemplateForm.State.tag === 0) {
                            return singleton(createElement(Button, {
                                ComponentState: props.ComponentState,
                                Label: t("general.save"),
                                OnClick: () => {
                                    props.Dispatch(new Msg(49, []));
                                },
                                TestId: "save-button-checklist-definition-test-id",
                                Variant: "primary",
                            }));
                        }
                        else {
                            return empty();
                        }
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement(TabsMenu, {
        Tabs: ofArray([tab(new EditorTab(0, []), t("procedure.form.tab_structure"), "procedure-template-tab-structure"), tab(new EditorTab(1, []), t("procedure.form.tab_general"), "procedure-template-tab-general"), tab(new EditorTab(2, []), `${hooksTabLabel} (${enabledHookCount})`, "procedure-template-tab-hooks")]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function View(props) {
    let elems_1;
    const t = useTranslation()[0];
    const state = props.State;
    const dispatch = props.Dispatch;
    const availableLabels = map((label) => ({
        label: label.Name,
        value: LabelId__get_unwrap(label.Id),
    }), state.AvailableLabels);
    const availableRoles = map((role) => ({
        label: roleDisplayName(t, role),
        value: RoleId__get_unwrap(role.Id),
    }), filter(RoleDefinitionModule_isAssignable, state.AvailableRoles));
    const componentState = state.FormState.IsLoading ? "disabled" : "enabled";
    const structureComponentState = (props.ProcedureTemplateForm.State.tag === 0) ? componentState : "disabled";
    const sortedSteps = sortBy((_arg) => (_arg.Position | 0), props.ProcedureTemplateForm.Steps, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const selectedStep = bind((position) => tryFind((step) => (step.Position === position), sortedSteps), state.SelectedStepPosition);
    let inspector;
    const matchValue_4 = state.SelectedStepElementPosition;
    if (selectedStep == null) {
        inspector = createElement(InspectorEmpty, null);
    }
    else if (matchValue_4 == null) {
        const step_3 = selectedStep;
        inspector = createElement(InspectorStep, {
            ComponentState: structureComponentState,
            Dispatch: dispatch,
            FormState: state.FormState,
            Position: step_3.Position,
            SelectedStep: step_3,
        });
    }
    else {
        const elementPosition_1 = matchValue_4 | 0;
        const step_2 = selectedStep;
        const matchValue_6 = tryFind((stepElement) => (stepElement.Position === elementPosition_1), step_2.Elements);
        if (matchValue_6 == null) {
            inspector = createElement(InspectorEmpty, null);
        }
        else {
            const stepElement_1 = matchValue_6;
            inspector = createElement(InspectorStepElement, {
                AvailableInspectionTemplates: state.AvailableInspectionTemplates,
                AvailableUsers: state.AvailableUsers,
                ComponentState: structureComponentState,
                Dispatch: dispatch,
                FormState: state.FormState,
                Position: step_2.Position,
                PropertyConfigurations: state.PropertyConfigurations,
                SelectedStepElement: stepElement_1,
                ToolStates: toolStateChangeOptions(state.CustomStatesEnabled, state.InventoryStates, stepElement_1.Options),
            });
        }
    }
    return reactElement("div", createObj(singleton_1((elems_1 = toList(delay(() => append(singleton(createElement(EditorHeader, {
        ComponentState: componentState,
        Dispatch: dispatch,
        ProcedureTemplateForm: props.ProcedureTemplateForm,
        State: state,
    })), delay(() => {
        let matchValue_7, elems;
        return append((matchValue_7 = state.ActiveTab, (matchValue_7.tag === 1) ? singleton(createElement(GeneralTab, {
            ComponentState: componentState,
            Dispatch: dispatch,
            FormState: state.FormState,
            ProcedureTemplateForm: props.ProcedureTemplateForm,
            PropertyConfigurations: state.PropertyConfigurations,
        })) : ((matchValue_7.tag === 2) ? singleton(createElement(HooksTab, {
            AvailableLabels: availableLabels,
            AvailableRoles: availableRoles,
            ComponentState: componentState,
            Dispatch: dispatch,
            Hooks: state.Hooks,
            ProcedureTemplateForm: props.ProcedureTemplateForm,
            TargetStates: sortBy((definition_2) => [definition_2.SortOrder, definition_2.Key], filter((definition_1) => {
                if (definition_1.IsSystem) {
                    return true;
                }
                else {
                    return state.CustomStatesEnabled;
                }
            }, state.InventoryStates), {
                Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
            }),
        })) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[17rem_minmax(0,1fr)_22rem]", "gap-6", "items-start"])], (elems = [createElement(Sidebar, {
            ComponentState: isEmpty(sortedSteps) ? "disabled" : structureComponentState,
            DragSteps: state.DragSteps,
            OnAdd: (dragStepType) => {
                let matchValue_3;
                const matchValue_1 = tryLast(sortedSteps);
                if (selectedStep == null) {
                    if (matchValue_1 == null) {
                    }
                    else {
                        const lastStep = matchValue_1;
                        dispatch(new Msg(11, [lastStep.Position, length(lastStep.Elements), dragStepType]));
                    }
                }
                else {
                    const step_1 = selectedStep;
                    dispatch(new Msg(11, [step_1.Position, (matchValue_3 = state.SelectedStepElementPosition, (matchValue_3 == null) ? length(step_1.Elements) : (matchValue_3 + 1)), dragStepType]));
                }
            },
        }), createElement(MainArea, {
            ComponentState: structureComponentState,
            Dispatch: dispatch,
            FormState: state.FormState,
            ProcedureTemplateForm: props.ProcedureTemplateForm,
            SelectedStepElementPosition: unwrap(state.SelectedStepElementPosition),
            SelectedStepPosition: unwrap(state.SelectedStepPosition),
        }), inspector], ["children", reactApi.Children.toArray(Array.from(elems))])])))))), delay(() => {
            let matchValue_8;
            return append((matchValue_8 = state.TestRun, (matchValue_8 == null) ? (empty()) : singleton(createElement(TestProcedureModal, {
                IsOpen: true,
                OnClose: () => {
                    dispatch(new Msg(68, []));
                },
                TestRun: matchValue_8,
            }))), delay(() => {
                let Title;
                return append(singleton(createElement(ConfirmationDialog, (Title = t("procedure.action.release"), {
                    Description: t("procedure.action.release_confirmation"),
                    FormState: state.FormState,
                    IsOpen: state.IsReleaseDialogOpen,
                    OnClose: () => {
                        dispatch(new Msg(53, []));
                    },
                    OnConfirm: () => {
                        dispatch(new Msg(52, []));
                    },
                    Title: Title,
                }))), delay(() => {
                    let Title_1;
                    return append(singleton(createElement(ConfirmationDialog, (Title_1 = t("procedure.action.archive"), {
                        Description: t("procedure.action.archive_confirmation"),
                        FormState: state.FormState,
                        IsOpen: state.IsArchiveDialogOpen,
                        OnClose: () => {
                            dispatch(new Msg(59, []));
                        },
                        OnConfirm: () => {
                            dispatch(new Msg(58, []));
                        },
                        Title: Title_1,
                    }))), delay(() => {
                        let Title_2;
                        return append(singleton(createElement(ConfirmationDialog, (Title_2 = t("procedure.action.delete"), {
                            Description: t("procedure.action.delete_confirmation"),
                            FormState: state.FormState,
                            IsOpen: state.IsDeleteDialogOpen,
                            OnClose: () => {
                                dispatch(new Msg(63, []));
                            },
                            OnConfirm: () => {
                                dispatch(new Msg(62, []));
                            },
                            Title: Title_2,
                        }))), delay(() => {
                            let Title_3;
                            return singleton(createElement(ConfirmationDialog, (Title_3 = t("procedure.action.duplicate"), {
                                Description: t("procedure.action.duplicate_confirmation"),
                                FormState: state.FormState,
                                IsOpen: state.IsDuplicateDialogOpen,
                                OnClose: () => {
                                    dispatch(new Msg(71, []));
                                },
                                OnConfirm: () => {
                                    dispatch(new Msg(70, []));
                                },
                                Title: Title_3,
                            })));
                        }));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

export function NewView() {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureTemplate;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        return createElement(View, {
            Dispatch: patternInput[1],
            ProcedureTemplateForm: matchValue.fields[0],
            State: state_1,
        });
    }
}

export function EditView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEdit, update_1, (_arg, _arg_1) => {
    }), props.ProcedureTemplateId, [toString(props.ProcedureTemplateId)]);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureTemplate;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(View, {
            Dispatch: patternInput[1],
            ProcedureTemplateForm: matchValue.fields[0],
            State: state_1,
        });
    }
}

export function CopyView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initCopy, update_1, (_arg, _arg_1) => {
    }), props.ProcedureTemplateId, [toString(props.ProcedureTemplateId)]);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureTemplate;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(View, {
            Dispatch: patternInput[1],
            ProcedureTemplateForm: matchValue.fields[0],
            State: state_1,
        });
    }
}

